import { DisplayOption, FilterableMenuItem } from 'owa-filterable-menu';
import loc from 'owa-localize';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import { lazyReloadTextPreview, SxSStore } from 'owa-sxs-store';
import { PreviewPaneMode } from 'owa-sxsdata';
import {
    ansiText,
    autoDetectText,
    encodingText,
    utf8Text,
} from './getTextPreviewEncodingOptions.locstring.json';
import logSxSCommandBarDatapoint from './logSxSCommandBarDatapoint';

export default function getTextPreviewEncodingOptions(sxsStore: SxSStore): FilterableMenuItem {
    const name = loc(encodingText);
    const readMode = sxsStore.extendedViewState.textPreviewReadMode;
    const textPreviewEncodingOptionsButton = new FilterableMenuItem(
        name,
        null /* icon */,
        () => {
            logSxSCommandBarDatapoint('OpenInNewTab', {
                customData: { isLink: !sxsStore.extendedViewState.attachmentId },
            });
        },
        () =>
            sxsStore.viewState.previewPane &&
            sxsStore.viewState.previewPane.mode === PreviewPaneMode.Text,
        DisplayOption.Overflow,
        false /* disabled */,
        [
            {
                key: 'autoDetect',
                text: loc(autoDetectText),
                onClick: () => {
                    onContextMenuItemClick(GetAttachmentTextPreviewReadMode.AutoDetect);
                },
                canCheck: true,
                checked: !readMode,
            },
            {
                key: 'ANSI',
                text: loc(ansiText),
                onClick: () => {
                    onContextMenuItemClick(GetAttachmentTextPreviewReadMode.ANSI);
                },
                canCheck: true,
                checked: readMode === GetAttachmentTextPreviewReadMode.ANSI,
            },
            {
                key: 'UTF8',
                text: loc(utf8Text),
                onClick: () => {
                    onContextMenuItemClick(GetAttachmentTextPreviewReadMode.UTF8);
                },
                canCheck: true,
                checked: readMode === GetAttachmentTextPreviewReadMode.UTF8,
            },
        ]
    );
    textPreviewEncodingOptionsButton.ariaLabel = name;
    return textPreviewEncodingOptionsButton;
}

async function onContextMenuItemClick(readMode: GetAttachmentTextPreviewReadMode) {
    const reloadTextPreview = await lazyReloadTextPreview.import();
    reloadTextPreview(readMode);

    logSxSCommandBarDatapoint('TextPreviewEncodingOption', {
        customData: { readMode },
    });
}
